import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPerson } from '@fortawesome/free-solid-svg-icons'
import '../../../assets/css/pages/Expeditions/SelfGroupCard.css'

const SelfGroupCard = React.memo(() => {
	return (
		<div className='SelfGroupCard'>
			<h4>
				<span>Group 1</span>
				<span>
					<FontAwesomeIcon
						icon={faPerson}
						style={{
							width: '16px',
							height: '16px',
							marginRight: '4px'
						}}
					/>
					1
				</span>
			</h4>
			<div className='SelfGroupCard__groupBody'>
				<span>Myself</span>
			</div>
		</div>
	)
})
export default SelfGroupCard
